export default __webpack_public_path__ + "static/media/right-emergencia.c14121c6.png";